import { styled } from '@mui/material/styles';
import { DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PREFIX = 'ClientWizardFooter';

const classes = {
  footer: `${PREFIX}-footer`,
  button: `${PREFIX}-button`,
};

const Root = styled(DialogActions)(({ theme }) => ({
  [`&.${classes.footer}`]: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(18),
      paddingBottom: theme.spacing(4),
      paddingLeft: 0,
      gap: theme.spacing(2),
      '& button': {
        flex: 'none',
      },
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  [`& .${classes.button}`]: {
    fontSize: '15px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      '&:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },
    },
    width: '144px',
  },
}));

interface ClientWizardFooterProps {
  isFirst: boolean;
  isLast: boolean;
  isSaving: boolean;
  isValid: boolean;
  next: (data: any) => void;
  close: () => void;
  cancel: () => void;
}

export default function ClientWizardFooter({
  isFirst,
  isLast,
  isSaving,
  isValid,
  next,
  close,
  cancel,
}: ClientWizardFooterProps) {
  const { t } = useTranslation('common');

  return (
    <Root className={classes.footer}>
      {!isLast && (
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          disabled={!isValid}
          onClick={next}>
          {t('reservation.next')}
        </Button>
      )}
      {isLast && (
        <Button
          color="primary"
          variant="contained"
          disabled={isSaving || !isValid}
          className={classes.button}
          onClick={close}>
          {t('common.submit')}
        </Button>
      )}
      <Button
        color="primary"
        variant="outlined"
        className={classes.button}
        onClick={cancel}>
        {t('common.cancel')}
      </Button>
    </Root>
  );
}
